// extracted by mini-css-extract-plugin
export default {"callOut":"callOut__FTc0o"};